import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetalhesCobrancaComponent } from './detalhes-cobranca.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatIconModule, MatSelectModule, MatCheckboxModule, MatTableModule, MatPaginatorModule, MatNativeDateModule, MatDialogModule, MatCardModule, MatSortModule, MatTooltipModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';


const routes = [
    {
        path: 'detalhesCobranca',
        component: DetalhesCobrancaComponent
    }
];
@NgModule({
    declarations: [DetalhesCobrancaComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        SharedModule,
        NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
        Ng4LoadingSpinnerModule,
        MatButtonModule,
        FuseSharedModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTableModule,
        MatPaginatorModule,
        MatNativeDateModule,
        MatDialogModule,
        MatCardModule,
        MatSortModule,
        MatTooltipModule
    ],
    exports: [DetalhesCobrancaComponent]
})
export class DetalhesCobrancaModule { }
